import { Link } from "react-router-dom";

export function buildUsernameMapFromDiscussions(discussions) {
  const map = new Map();
  if (!Array.isArray(discussions)) return map;
  discussions.forEach((discussion) => {
    const author = discussion.createdBy;
    if (author?.username && author?._id) {
      map.set(author.username, author._id);
    }
    (discussion.replies || []).forEach((reply) => {
      if (reply?.user?.username && reply?.user?._id) {
        map.set(reply.user.username, reply.user._id);
      }
    });
  });
  return map;
}

export default function MentionText({ text, usernameToId }) {
  if (!text) return null;
  const parts = String(text).split(/(@[a-zA-Z0-9_.-]{2,30})/g);
  return parts.map((part, idx) => {
    const mentionMatch = /^@([a-zA-Z0-9_.-]{2,30})$/.exec(part);
    if (mentionMatch) {
      const username = mentionMatch[1];
      const id = usernameToId?.get?.(username);
      if (id) {
        return (
          <Link
            key={`m-${idx}`}
            to={`/users/${username}`}
            className="peer-home-link hover:underline"
          >
            @{username}
          </Link>
        );
      }
      return (
        <span key={`m-${idx}`} className="text-[#f26522] font-semibold">
          @{username}
        </span>
      );
    }
    return <span key={`t-${idx}`}>{part}</span>;
  });
}
